import { Box, Flex, Stack, Switch, Text, useToast } from '@chakra-ui/react';
import React from 'react';
import { useApolloClient, useMutation } from '@apollo/client';
import { useError } from '../../../error-provider/ErrorProvider';

import { FillerAudio } from '../../../graphql/mutations/FillerAudio';
import ZaraButton from '../../custom-components/buttons/Button';
import { CreatePortalSession } from '../../../graphql/mutations/CreatePortalSession';
import { MANAGE_TYPE } from '../subscription/SubscriptionComponent';

const FillAudio = ({ data, isPremium, agentId }) => {
    const toast = useToast();
    const { showError } = useError();

    const apolloClient = useApolloClient();

    const [onFillAudio, { loading }] = useMutation(FillerAudio, {
        onError(error) {
            showError(undefined, error);
        },
    });

    const active = data?.active ?? false;

    const isDisabled = !isPremium;

    const [onChangeSubscription] = useMutation(CreatePortalSession, {
        onError(error) {
            showError(undefined, error);
        },
    });

    async function onSubmit(manageType) {
        try {
            await onChangeSubscription({
                variables: {
                    manageType: manageType,
                },
                onCompleted(data) {
                    if (data?.createPortalSession?.success) {
                        window.location.href = data?.createPortalSession?.portalSessionUrl;
                    } else {
                        toast({
                            title: data?.createPortalSession?.error,
                            status: 'error',
                            isClosable: true,
                        });
                    }
                },
            });
        } catch (error) {}
    }

    async function changeTransfer(isActive) {
        const variables = {
            active: isActive,
        };
        await onFillAudio({
            variables: { ...variables, agentId: agentId },
            onCompleted(data) {
                if (data.fillerAudio.__typename === 'SuccessType') {
                    toast({
                        title: data.fillerAudio.message,
                        status: 'success',
                        isClosable: true,
                    });

                    apolloClient.cache.modify({
                        id: `AgentType:${agentId}`,
                        fields: {
                            fillerAudio() {
                                return variables;
                            },
                        },
                    });
                } else {
                    toast({
                        title: data.fillerAudio.message,
                        status: 'error',
                        isClosable: true,
                    });
                }
            },
        });
    }

    return (
        <Box>
            <Flex
                fontSize={{ base: '24px', sm: '28px' }}
                lineHeight='28px'
                fontWeight={{ base: '400', sm: '700' }}
                textAlign='left'
                gap='10px'
                alignItems='center'
                mb='10px'
            >
                <Stack direction='row' alignItems='center'>
                    <Switch
                        isDisabled={isDisabled || loading}
                        isChecked={active}
                        onChange={() => changeTransfer(!active)}
                    />
                    <Stack spacing='0'>
                        <Text fontSize='md'>Add Filler Audio</Text>
                        <Text fontSize='sm' color='#6b7280' fontWeight='300'>
                            Your AI agent will play keyboard typing sounds instead of silence while it thinks of its
                            response.
                        </Text>
                    </Stack>
                </Stack>
                {isDisabled && (
                    <ZaraButton onClick={() => onSubmit(MANAGE_TYPE.UPDATE)} w='fill-content'>
                        Upgrade to Unlock
                    </ZaraButton>
                )}
            </Flex>
            {active && !isDisabled && (
                <Stack spacing='12px' maxW='500px'>
                    <Text fontWeight={{ base: '400', sm: '700' }} color='green'>
                        Your AI agent will play keyboard typing sounds instead of silence while it thinks of it's
                        response.
                    </Text>
                </Stack>
            )}
        </Box>
    );
};

export default FillAudio;
